// import PropTypes from "prop-types";
import BasicReactTableWrapper from "../../../shared_components/basic_react_table_wrapper";

class CitiesBreakdownTable extends BasicReactTableWrapper {
}

CitiesBreakdownTable.propTypes = Object.assign({}, BasicReactTableWrapper.propTypes, {
});


export default CitiesBreakdownTable;
